module.exports = __webpack_public_path__ + "static/img/40011 (1).39247b8.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40011 (1).webp
// module id = VDEn
// module chunks = 14